import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id CB446614-AE63-403E-BBF8-0B0ED3E367AE
 * name television-box
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-box.svg
 * tags
 */
export const TelevisionBoxIcon = createSvgIcon(<><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M16,16L19,8H16.5L15,12.5L13.5,8H5V10H8V16H10V10H11.77L14,16H16Z" /></>, 'TelevisionBoxIcon');
export default TelevisionBoxIcon